import { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import TimeFrameInformation from "../../Pages/BudgetAndTimeFrame/TimeFrameInformation";
import loadConfig from "../../Services/apiService";
import Objectives from "../../Pages/BudgetAndTimeFrame/Objectives";
import ObjectivesActivities from "../../Pages/BudgetAndTimeFrame/ObjectivesActivities";
import BudgetDirectCosts from "../../Pages/BudgetAndTimeFrame/BudgetDirectCosts";
import BudgetAdministrativeCosts from "../../Pages/BudgetAndTimeFrame/BudgetAdministrativeCosts";
import ButtonAHSF from "../../Components/ButtonAHSF";
import DetailsBudget from "../../Pages/BudgetAndTimeFrame/BudgetDetails";
import PopupAHSF from "../../Components/PopupAHSF";
import { ValidationBudget } from "../../Redux/Reducers/BudgetInformation/ValidationBudget";
import { useDispatch, useSelector } from "react-redux";
import { Await, json, useNavigate } from "react-router-dom";
import './style.css'
import $ from "jquery";
const BudgetTimeFrame = () => {
  const dispatch = useDispatch() // Hook from react-redux used to dispatch actions to the Redux store
  const navigat = useNavigate(); // Hook from react-router-dom used for page navigation
  const validationList = useSelector((state) => state.ValidationBudget?.ValidationBudgetList) // Accessing the validation list from the Redux store
  const [PopupComponentViewStatus, setPopupComponentViewStatus] =
    useState(false); // State to control whether the details popup is visible or not
  const [PopupComponentValidationViewStatus, setPopupComponentValidationViewStatus] = useState(false); // State to control whether the validation popup is visible or not
  const [jsonData, setJsonData] = useState(); // State to store the data loaded from the external file
  const state = useSelector((state) => { // Accessing various parts of the Redux store
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      ApplicationInformationloding: state.ApplicationInformation,
      BeneficiaryInformation:
        state.BeneficiaryInformation.BeneficiaryInformation,
      GeneralInformation: state.GeneralInformation.GeneralInformation,
      PersonalInformation: state.PersonalInformation.PersonalInformation,
      ApplicationInformationValidationPage:
        state.ApplicationInformationValidationPage
          .ApplicationInformationValidationPage,
      ActiveRound: state.ApplicationInformation.ActiveRound, // Accessing active round information
      BI_TimelineInformation:state.BI_TimelineInformation.Validation // Accessing validation information from the timeline
    };
  });

  const dataJson = async () => { // Async function to load data
    let jsonData = await loadConfig(); // Loading data from an external source
    setJsonData(jsonData); // Storing the loaded data in state
  };

  useEffect(() => { // Effect that runs when the component is mounted
    dataJson(); // Loading data on component mount
  }, []); // This effect runs only once when the component is mounted

  const closePopupViewComponent = () => { // Function to toggle the visibility of the details popup
    if (PopupComponentViewStatus) {
      setPopupComponentViewStatus(false); // Closing the popup
    } else {
      setPopupComponentViewStatus(true); // Opening the popup
    }
  };

  const closePopupComponentValidationViewStatus = () => { // Function to toggle the visibility of the validation popup
    if (PopupComponentValidationViewStatus) {
      setPopupComponentValidationViewStatus(false); // Closing the popup
    } else {
      setPopupComponentValidationViewStatus(true); // Opening the popup
    }
  };

  //console.log(state.BI_TimelineInformation,"ssssdsdswwwwwwwww");

  const validation_ = async () => { // Async function to perform budget validation and send the request
    const result = await dispatch(ValidationBudget({ aI_ApplicationInformationId: localStorage.getItem("aI_ApplicationInformationId") })); // Dispatching the validation action
    //console.log(validationList, "lksldkkdkdkkkdkkff");
    // After validation, if the list is empty, navigate to the next page
    if (result.payload.length == 0) {
      $(".AttachmentsAndPledge").trigger("click"); // Trigger the click event to navigate to the next page
    } else {
      closePopupComponentValidationViewStatus(); // If there are validation messages, close the validation popup
    }
  };

  const shouldDisableFields = !(
    //[,]
    // User can't edit if the round is not active, or the application status is pending review, or the user is not a manager
    state.ActiveRound == 
      state.ApplicationInformation?.aI_RoundYearId && // If the round is active
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite && // If the application status allows editing
    window.location.href.includes("manager") == false // If the user is not a manager
  );

  return (
    <>
      <div>
        <SharedDiv
          showTitle={true}
          titleName={jsonData ? jsonData.TimeFrameInformation.nameAR : ""} // Display the translated title of the time frame information
          child={[<TimeFrameInformation />]} // Display the TimeFrameInformation component
          showButton={true} 
          id_Title="withBtnTitle"

          buttonComponent={ // Display a button to show the budget summary
            <ButtonAHSF
              id={"btnTitle"}
              type={"submitter"}
              onClick={() => {
                closePopupViewComponent(); // Close the details popup when the button is clicked
              }}
              disabled={false}
              title={"عرض ملخص الموازنة"}
              text={"عرض ملخص الموازنة"}
              show={true}
            />
          }
        />
        <SharedDiv
          showTitle={false}
          child={[ 
            <div>
              <Objectives /> 
              <ObjectivesActivities />
              <BudgetDirectCosts /> 
              <BudgetAdministrativeCosts />
            </div>,
          ]}
        />
      </div>

      <PopupAHSF
        title={"تفاصيل الموازنة التقديرية"} // Title for the details popup
        componentBody={<DetailsBudget />} // Body of the popup containing the budget details component
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentViewStatus} // Popup open status
        isPopupOpenFunction={closePopupViewComponent} // Function to close the popup
      />

      <PopupAHSF
        title={"يرجى تعبئة الحقول المطلوبة"} // Title for the validation popup
        componentBody={
          <>
            {validationList &&
              validationList.map((ele, ind) => {
                return (
                  <>
                    <p>{ele.message}</p> 
                  </>
                );
              })}
          </>
        }
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentValidationViewStatus} // Popup open status
        isPopupOpenFunction={closePopupComponentValidationViewStatus} // Function to close the popup
      />

      {!shouldDisableFields ? ( // If the fields are not disabled, show the "Next" button
        <div className="containerButtonMAin">
          <ButtonAHSF onClick={validation_} text={"التالي"} show={true} /> 
        </div>
      ) : (
        <></> // If the fields are disabled, do not display the "Next" button
      )}
    </>
  );
};

export default BudgetTimeFrame;

